export interface ASIProducts {
  region: string;
  hwType: string;
  asiCode: string;
  description: string;
  make: string;
  authMethod: string;
  generation: string;
  platform: string;
  platformExtended?: string;
  mpc: Array<string>;
  manufacturer: string;
  capabilities: Array<string | object>;
}

export const initialASIProduct: ASIProducts = {
  region: '',
  hwType: '',
  asiCode: '',
  description: '',
  make: '',
  authMethod: '',
  generation: '',
  platform: '',
  mpc: [],
  manufacturer: '',
  capabilities: [],
};

export const asiColumns = ['Region', 'HW Type', 'ASI', 'MPC', 'Platform', 'Mfr.', 'Launch',
  'Make', 'Auth Method', 'Description'];
export const asiColumnsV2 = [...asiColumns, 'Platform Extended'];
export const columnToPropertyMapping = {
  'Region': 'region',
  'HW Type': 'hwType',
  'ASI': 'asiCode',
  'MPC': 'mpc',
  'Platform': 'platform',
  'Platform Extended': 'platformSubType',
  'Mfr.': 'manufacturer',
  'Launch': 'launch',
  'Make': 'make',
  'Description': 'description',
  'Auth Method': 'authMethod',
};
export const productBundleV2 = ['Region', 'HW Type', 'ASI', 'MPC', 'Platform', 'Platform Extended', 'Mfr.', 'Launch', 'Make', 'Auth Method',
'Description', 'Additional Description \r\n(Remote Options)', 'Trial', 'Paid Bundles', 'Goodwill Bundles', 'PPO']

export interface productBundle {
  region: string;
  hwType: string;
  asiCode: string;
  mpc: Array<string>;
  platform: string;
  platformSubType: string;
  manufacturer: string;
  generation: string;
  make: string;
  authMethod: string;
  description: string;
  productIds: Array<string>;
}
export const initialproductBundle: productBundle = {
  region: '',
  hwType: '',
  asiCode: '',
  description: '',
  make: '',
  platform: '',
  platformSubType: '',
  generation: '',
  authMethod: '',
  manufacturer: '',
  mpc: [],
  productIds: []
};

export const columnToproductBundleMapping = {
  'Region' : 'region', 
  'HW Type': 'hwType', 
  'ASI': 'asiCode',
  'Description': 'description',
  'Make': 'make', 
  'Platform': 'platform', 
  'Platform Extended': 'platformSubType', 
  'Launch': 'generation', 
  'Auth Method': 'authMethod',
  'Mfr.': 'manufacturer', 
  'MPC': 'mpc',
  'productIds': 'productIds'
};
